import React from "react";
import PropTypes from "prop-types";
import NoImage from "static/images/no-image.png";
import VideoPosterDefault from "static/images/video-poster-default.png";

const AssetWithFallback = ({ format = "png", preview = false, className, ...props }) => {
  const handleError = event => {
    event.target.src = NoImage;
  };

  if (format === "mp4") {
    if (preview) {
      return <img className={className} width={100} height={75} src={VideoPosterDefault} />;
    } else {
      return (
        <video preload="none" style={{ maxWidth: "100%" }} controls onError={handleError}>
          <source {...props} />
        </video>
      );
    }
  }
  return <img onError={handleError} className={className} {...props} />;
};

AssetWithFallback.propTypes = {
  /**
   * Clase del componente
   **/
  className: PropTypes.string,
  /**
   * Show as preview or thumbnail
   **/
  preview: PropTypes.bool,
  /**
   * Format of media [png, apng, mp4]
   **/
  format: PropTypes.string,
  /**
   * Height of media
   **/
  height: PropTypes.number,
  /**
   * Width of media
   **/
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default AssetWithFallback;
